import { Component, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../auth.service';

@Component({
  selector: 'app-ve',
  templateUrl: './ve.component.html',
  styleUrls: ['./ve.component.scss']
})
export class VeComponent {
  public readonly authService: AuthenticationService;
  module: any;

  constructor(
    private readonly injector: Injector,
    public router: Router,
    ) {
      this.authService = injector.get(AuthenticationService);

      this.module = this.authService.getModule();
     }

    get adminRoute() {
      return this.module === 'VE_Body' ? 'Administration/Body-Program-Details' : 'Administration/Ga-Program-Details';
    }
}
